module.exports = __webpack_public_path__ + "874c19c760eda8e6ae2a.worklet.js";